import { render, staticRenderFns } from "./Dashcam.vue?vue&type=template&id=7963cb1f&scoped=true&"
import script from "./Dashcam.vue?vue&type=script&lang=js&"
export * from "./Dashcam.vue?vue&type=script&lang=js&"
import style0 from "./Dashcam.vue?vue&type=style&index=0&id=7963cb1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7963cb1f",
  null
  
)

export default component.exports